// extracted by mini-css-extract-plugin
module.exports = {"offerAlert-container":"OfferAlert_offerAlert-container__1ynCZ","offerAlert__inner":"OfferAlert_offerAlert__inner__2qHDE"};